import { connect } from 'react-redux';
import * as metaSelectors from 'redux-modules/meta/selectors.js';
import Notification from './Notification';

function mapStateToProps(state) {
  return {
    meta: metaSelectors.selectMeta(state)
  };
}

export default connect(mapStateToProps, null)(Notification);
